module.exports = __webpack_public_path__ + "img/mobile-sketches.aa0aaf11.png";